import { useSelector } from 'react-redux';
import { isZeroEyesEnabled } from '@rsos/reduxDataStore';
import { RootState } from '../app';

const useIsZeroEyesEnabled = () => {
  return useSelector((state: RootState) => isZeroEyesEnabled(state));
};

export default useIsZeroEyesEnabled;
